import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { AuthServiceService } from 'src/app/shareModule/services/auth-service.service';


@Component({
  selector: 'app-admin-stats',
  templateUrl: './admin-stats.component.html',
  styleUrl: './admin-stats.component.scss'
})
export class AdminStatsComponent implements OnInit{

  constructor(private auth: AuthServiceService, private toastr: ToastrService){}


  ngOnInit(): void {
    this.getVisitInfos()
  }


  public last24HoursVisitCount = 0;
  public allVisitInfos = [];

  public dateSelected = null;
  public countOnSelectedDate = null;

  public seeCountsOn(e){
    const v = e.target.value;
    console.log({v})
    const selectedDatData = this.allVisitInfos.find(data => data.date == v);
    if(selectedDatData){
      this.countOnSelectedDate = selectedDatData.count
    }
    this.dateSelected = v;

  }



  public chartOptions = {
    responsive: true,
    scales: {
      x: {
        title: {
          display: true,
          text: 'Days',
        },
      },
      y: {
        title: {
          display: true,
          text: 'Visitors',
        },
      },
    },
  };

  private getRandomColor(): string {
    const letters = '0123456789ABCDEF';
    let color = '#';
    for (let i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  }


  public chartLabels = [];
  public chartData = {
    labels: this.chartLabels,
    datasets: [
      {
        data: [],
        label: 'Visitors',
        fill: false,
        backgroundColor: this.getRandomColor(),
        borderColor: 'rgba(75, 192, 192, 1)',
        tension: 0.1,
      },
    ],
  };

  private getVisitInfos(){
    this.auth.getVisitorInfos().subscribe({
      next: (data: any)=>{
        this.allVisitInfos =  data.data.allDayInfos;
        this.last24HoursVisitCount = data.data.last24hoursSlidingCount
        this.chartData.datasets[0].data = Array.from(this.allVisitInfos.map(d => d.count));
        this.chartData.labels = this.allVisitInfos.map(d => d.date);
        const tmp = this.chartData;
        console.log(this.chartData, this.chartLabels );
        this.chartData = null;
        this.chartData = structuredClone(tmp)
      },
      error: (err)=>{
        console.error(err);
        this.toastr.error("Error While fetching infos");
      }
    })
  }

}
